import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadReportExportByIdFailed, loadReportExportByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadReportExportById(action) {
  try {
    const url = `${BACKEND_URL}/resources/report-export/${action.payload}`;
    yield put(loadReportExportByIdSuccessful({
      id: 1,
      data: 'Получение данных от ГИС ГМП о штрафах',
      service: 'SID0003998 Электронный сервис государственной информационной системы о государственных и муниципальных платежах',
      source: 'СМЭВ СПб',
      created_at: '2024-12-12',
      status: '1',
      procedures: ['1227.1', '1227.2', '1227.3'],
    }));
    yield call(resolveActionPromise(action));
    // const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    // if (dataResponse.status === OK) {
    //   const data = yield dataResponse.json();
    //   yield put(loadReportExportByIdSuccessful(data.data));
    //   yield call(resolveActionPromise(action, data.data));
    // } else {
    //   yield put(loadReportExportByIdFailed());
    //   yield call(rejectActionPromise(action));
    // }
  } catch (e) {
    yield put(loadReportExportByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
